import initialUserState from './initialUserState'

export const allCommanCaesList = {
  update: 'COMMAN_UPDATE',
  reset: 'COMMAN_RESET',
}

const cases = {
  [allCommanCaesList.update]: (state, payload) => {
    return {
      ...state,
      ...payload,
    }
  },
  [allCommanCaesList.reset]: () => {
    return { ...initialUserState }
  },
}

const reducer = (state, action) => {
  return cases[action.type](state, action.payload)
}

export default reducer
